var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#E4E8EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0494 31.9192C34.1841 29.422 31.7621 27.3942 28.9757 25.9971C26.1894 24.5999 23.1156 23.8719 19.9986 23.871C16.8817 23.87 13.8074 24.596 11.0202 25.9914C8.23303 27.3868 5.80972 29.4131 3.94287 31.9092C5.80022 34.4179 8.21958 36.4565 11.0069 37.8616C13.7943 39.2667 16.8721 39.999 19.9936 40C23.1151 40.001 26.1933 39.2705 28.9816 37.8672C31.7698 36.4639 34.1904 34.4268 36.0494 31.9192Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 21.2903C24.276 21.2903 27.7422 17.8241 27.7422 13.5483C27.7422 9.27258 24.276 5.8064 20.0002 5.8064C15.7245 5.8064 12.2583 9.27258 12.2583 13.5483C12.2583 17.8241 15.7245 21.2903 20.0002 21.2903Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.3e24904cb2b47bd2230669621080413b.svg";
export { ForwardRef as ReactComponent };